module.exports = __webpack_public_path__ + "img/SE.1f642770.svg";